import React from "react";

export default function SQL_CONSTRAINT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_CONSTRAINT</h1>
      <p>This is the SQL_CONSTRAINT component generated from the SQL JSON.</p>
    </div>
  );
}
